import {
  SHARED_FIELD,
  SHARED_FIELD_KEYS,
  isSharedFieldDefined,
  sharedFieldChanged,
  type SharedFieldKey,
} from "@/components/modules/listings/ListingDetail/components/sharedFieldCompare";

export type AssociationFieldKey = SharedFieldKey;

export type PropertyShared = {
  bedrooms?: number | null;
  bathrooms?: number | null;
  houseFeatures?: string[];
  latitude?: string | null;
  longitude?: string | null;
  locationNormalizedName?: string | null;
  petFriendly?: boolean | null;
  contract?: boolean | null;
  smokingAllowed?: boolean | null;
};

export type ListingShared = {
  bedrooms?: number | string | null;
  bathrooms?: number | string | null;
  houseFeatures?: string[];
  locationNormalizedName?: string | null;
  petFriendly?: boolean | null;
  contract?: boolean | null;
  smokingAllowed?: boolean | null;
};

export type AssociationField = { key: AssociationFieldKey; differs: boolean };

export function associationSharedFields(
  property?: PropertyShared | null,
  listing?: ListingShared | null,
): AssociationField[] {
  if (!property || !listing) return [];
  return SHARED_FIELD_KEYS.filter((key) =>
    isSharedFieldDefined(property, key),
  ).map((key) => ({
    key,
    differs: sharedFieldChanged(property, listing, key),
  }));
}

export function buildSharedFieldsUpdate(
  property: PropertyShared,
  keys: string[],
): Record<string, unknown> {
  const data: Record<string, unknown> = {};
  if (keys.includes(SHARED_FIELD.bedrooms))
    data.bedrooms = property.bedrooms ?? 0;
  if (keys.includes(SHARED_FIELD.bathrooms))
    data.bathrooms = property.bathrooms ?? 0;
  if (keys.includes(SHARED_FIELD.houseFeatures))
    data.houseFeatures = property.houseFeatures ?? [];
  if (keys.includes(SHARED_FIELD.location)) {
    data.latitude = property.latitude;
    data.longitude = property.longitude;
    data.locationNormalizedName = property.locationNormalizedName;
  }
  if (keys.includes(SHARED_FIELD.petFriendly))
    data.petFriendly = property.petFriendly ?? false;
  if (keys.includes(SHARED_FIELD.contract))
    data.contract = property.contract ?? false;
  if (keys.includes(SHARED_FIELD.smokingAllowed))
    data.smokingAllowed = property.smokingAllowed ?? false;
  return data;
}
